/**
 * Adds a 'touch' class to the HTML element on the first touch event.
 * 
 * This script listens for the first touch event on the window and adds a 
 * 'touch' class to the root HTML element (`<html>`). The event listener 
 * is removed after the first touch to avoid unnecessary checks and 
 * potential performance issues.
 */
window.addEventListener('touchstart', function onFirstTouch() {
    document.documentElement.classList.add('touch');
    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);